import Distribution from '.';

const Uniform: Distribution = (x: number) => x;

export default Uniform;
